import LeaveExamRoomModal, { LeaveExamRoomModalProps } from './LeaveExamRoomModal';

export default LeaveExamRoomModal;
export type { LeaveExamRoomModalProps };
